// Utilities
import { builderFetch } from '@builder/core/utilities';

// Translatable strings
const strings = UncannyAutomator._core.i18n.core.item.createItem;

/**
 * Create an item of a specific type with a given code.
 *
 * @param {string} itemType - Type of the item to be created. Expected "trigger", "action", or "closure".
 * @param {string} itemCode - Unique code for the item.
 * @param {object} [options={}] - Optional parameters.
 * @param {number} [options.parentID=UncannyAutomator._recipe.recipe_id] - ID of the parent item.
 * @param {Array} options.actionsOrder - Order of actions.
 * @param {object} options.defaultMeta - Default metadata.
 * @throws Will throw an error if the item type or item code is invalid.
 * @return {Promise} - Returns a promise that resolves to the API response.
 */
const createItem = (
	itemType,
	itemCode,
	{
		parentID = UncannyAutomator._recipe.recipe_id,
		actionsOrder,
		defaultMeta
	} = {}
) => {
	// Check for valid item type
	if ( ! [ 'trigger', 'action', 'closure' ].includes( itemType ) ) {
		throw new Error( 'Invalid item type provided. Expected "trigger", "action" or "closure".' );
	}

	// Check for valid item code
	if ( typeof itemCode !== 'string' ) {
		throw new Error( 'Invalid item code provided. Expected a string.' );
	}

	// Define action and snackbar messages based on item type
	let action, loadingMessage, successMessage;

	if ( itemType === 'trigger' ) {
		action = 'add-new-trigger';
		loadingMessage = strings.addingTrigger;
		successMessage = strings.triggerAdded;
	} else if ( itemType === 'action' ) {
		action = 'add-new-action';
		loadingMessage = strings.addingAction;
		successMessage = strings.actionAdded;
	} else {
		action = 'add-new-closure';
		loadingMessage = strings.addingAction;
		successMessage = strings.actionAdded;
	}

	// Send request to create the item
	return builderFetch( {
		endpoint: 'add',
		method: 'POST',
		data: {
			recipePostID: UncannyAutomator._recipe.recipe_id,
			// eslint-disable-next-line camelcase
			item_code: itemCode,
			action: action,
			// eslint-disable-next-line camelcase
			parent_id: parentID,
			// eslint-disable-next-line camelcase
			actions_order: actionsOrder,
			// eslint-disable-next-line camelcase
			default_meta: defaultMeta,
		},
		snackbar: {
			loading: loadingMessage,
			success: successMessage,
		}
	} );
}

export default createItem;
